module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_html.js
// module id = ./node_modules/core-js/library/modules/_html.js
// module chunks = 168707334958949